// PARA UTILIZAR UN DISTINTO SERVIDOR, USAR VARIABLES DE ENTORNO
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
// Se puede modificar el archivo .env, hacer
// > export REACT_APP_SERVER_URL=https://staging.genoma.work
// o si se tiene instalado now, se puede descargar el .env
// con toda la configuración
// > now env pull
export { SERVER_URL as default };
